module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_5.16409fec.png";